import React, {useEffect} from "react";
import NewsImage from "../../assets/news&blogs.png";
import "../CSS/styles.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

const NewsTop = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <div className="container-fluid mt-lg-5 mt-5 pt-4 px-0" data-aos="fade-down">
      <div className="row pt-0 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={NewsImage} alt="News and Blogs" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <h1 className="fw-bolder inter h0 mb-0">News & Insights</h1>
              <p className="wrc text-center mb-0 mt-lg-3 mt-0">
                Stay updated with our latest articles, research, and industry
                insights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsTop;

